import { HttpClient } from '@angular/common/http';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from 'rxjs';
import { environment } from '@env/environment';
import * as FingerprintJS from '@fingerprintjs/fingerprintjs';
import { toast } from 'ngx-sonner';
import { LocalStorageService } from './localstorage.service';
import { DeviceService } from './device.service';
import { isInvalidCredentialsError } from '../shared/utils/invalid-credentials.utils';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  hasInternetSubject = new BehaviorSubject<boolean>(true);
  consultor = new BehaviorSubject<any>(null);
  completeDeviceInfo: any = null;
  private onboardingData: WritableSignal<any> = signal({
  });

  constructor(private httpClient: HttpClient,
              private router: Router,
              private localstorageService: LocalStorageService,
              private deviceService: DeviceService,
    ) {
      const phone = localStorage.getItem('phone');
      const consultorName = localStorage.getItem('consultorName');
      const qr = localStorage.getItem('qr');
      const user = localStorage.getItem('user');
      const agency = localStorage.getItem('agency');
      const data = {
        phone: phone,
        name: consultorName,
        user: user,
        agency: agency,
        qrImage: qr,
      };
      this.consultor.next(data);
     }

  getNewSession(consultor: any) {
    return this.httpClient.post(`${environment.serverUrl}/checkSessionUpdatingDate`, { session: null, consultor: consultor });
  }

  setOnboardinData(onboardingData: any){
    this.onboardingData.set(onboardingData);
  }

  setValidateData(data: { code: string; message: string; type: string; data: { procedureId: number; expirationDate: string; creationDate: string; state: string; userId: number; identificationNumber: string; documentType: string; levelIdentity: number; transactionValidation: { validationId: number; validatorName: string; result: string; transactionValidationStatusId: number; transactionValidationStatus: string; }[]; documents: never[]; failedRedirectUrl: string; successRedirectUrl: string; data: string; userName: string; attribute: string; procedureType: number; originatorNames: string; originatorLastnames: string; }; traceId: string; }) {
    return this.httpClient.post(`${ environment.serverUrl }/setValidateData`, { data });
  }

  getOnboardingData(){
    return this.onboardingData();
  }

  setConsultor(internalCode: string,) {
    localStorage.removeItem('consultor');
    localStorage.removeItem('qr');
    localStorage.removeItem('phone');
    localStorage.removeItem('consultorName');
    localStorage.removeItem('user');
    localStorage.removeItem('agency');
    const session = localStorage.getItem('session');
    const deviceInfo = this.getDeviceInfo();

    return this.httpClient.post(`${ environment.serverUrl }/setConsultor`, {consultor:internalCode, session})
    .pipe(
      tap((response:any) => {
        this.localstorageService.set('consultor', internalCode);
        this.localstorageService.set('session', response.token);
        this.localstorageService.set('qr', `${environment.serverUrl}/assets/qr/${ response.qrCode }`);
        this.localstorageService.set('phone', response.phone);
        this.localstorageService.set('consultorName', response.name);
        this.localstorageService.set('user', response.user);
        this.consultor.next({
            phone: response.phone,
            name: response.name,
            user: response.user,
            qrImage:`${environment.serverUrl}/assets/qr/${ response.qrCode }`
        });
      }),
      tap(() => {
        FingerprintJS.load().then(fp => {
            fp.get().then(result => {
              const fingerprint = result.visitorId;
              this.completeDeviceInfo = {
                ...deviceInfo,
                fingerprint,
                web_version: localStorage.getItem('version'),
              };

              this.setDeviceData(this.completeDeviceInfo).subscribe({
                next: (response:any) => {
              },
              error: (error:any) => {
                console.error('Error', error);
              }});
            });
          });
      }),
      catchError((error: any) => {
        toast.error('No fue posible encontrar el asesor que intentas consultar.');
        return throwError(() => error);
      })
    )
  }

  getTypedPersonData() {
    return this.httpClient.post(`${ environment.serverUrl }/getTypedPersonData`, {});
  }

  getConsultorInfo(){
    return this.consultor.getValue();
  }

  getDeviceInfo(){
    return this.deviceService.getDeviceInfo();
  }

  getBalance() {
    return this.httpClient.post(`${ environment.serverUrl }/getBalance`, {});
  }

  setBalance(data: { incomeExtraActivity: number; outcome: number; assets: number; liabilities: number; }) {
    return this.httpClient.post(`${ environment.serverUrl }/setBalance`, data);
  }

  getForeign() {
    return this.httpClient.post(`${ environment.serverUrl }/getForeign`, {});
  }

  setForeign(value: any) {
    return this.httpClient.post(`${ environment.serverUrl }/setForeign`, value);
  }

  setForeningHasPublicJobManager(value:any) {
    return this.httpClient.post(`${ environment.serverUrl }/setForeningHasPublicJobManager`, value);
  }

  sendOTP() {
    return this.httpClient.post(`${ environment.serverUrl }/sendOTP`, { });
  }

  checkOTPUpdating(code: string) {
    return this.httpClient.post(`${ environment.serverUrl }/checkOTPUpdating`, { code });
  }

  checkOTPUpdatingLight(code: string) {
    return this.httpClient.post(`${ environment.serverUrl }/checkOTPUpdatingLight`, { code });
  }

  validateOTP(code: string) {
    return this.httpClient.post(`${ environment.serverUrl }/checkOTP`, { code });
  }

  getPrincipalActivityTypeId(){
    return this.httpClient.get(`${ environment.serverUrl }/getPrincipalActivityTypeId`);
  }

  getCategories(){
    return this.httpClient.get(`${environment.serverUrl}/app/listSavingCategory/getCategoryList`)
  }

  validateOnboardingTodayByIdentification(identification:string){
    return this.httpClient.post(`${ environment.serverUrl }/validateOnboardingTodayByIdentification`, {identification})
  }

  calculateQuota(quota: string | number) {
    return this.httpClient.post(`${environment.serverUrl}/app/contributions/calculateQuota`, {quota});
  }

  getConsultor() {
    return this.httpClient.post(`${ environment.serverUrl }/getConsultor`, {})
    .pipe(
      catchError((error: any) => {
        if(error.status === 0) {
          this.hasInternetSubject.next(false);
        }
        if (error.status === 401 || (error.status === 403)) {
          localStorage.clear();
          this.router.navigate(['/']);
          return this.getNewSession(null);
        }
        return error;
      }),
      tap((response: any) => {
        if(!!response.name) {
          localStorage.setItem('qr', `${environment.serverUrl}/assets/qr/${ response.qrCode }`);
          localStorage.setItem('phone', response.phone);
          localStorage.setItem('consultorName', response.name);
          localStorage.setItem('user', response.user);
          localStorage.setItem('agency', response.agency);

          this.consultor.next({
            phone: response.phone,
            name: response.name,
            user: response.user,
            agency: response.agency,
            qrImage: `${environment.serverUrl}/assets/qr/${ response.qrCode }`
          });

        }
      }),
      map((response: any) => {
        this.hasInternetSubject.next(true);
        return response;
      }),
    )
    ;
  }

  getCheckpoint(){
    return this.httpClient.get(`${environment.serverUrl}/getCheckpoint`)
  }

  setActiveServices(activeServices: string[]) {
    return this.httpClient.post(`${ environment.serverUrl }/setActiveServices`, {activeServices});
  }

  setDeviceData(deviceData: any) {
    return this.httpClient.post(`${ environment.serverUrl }/app/deviceCustomer/addDevice`, deviceData);
  }

  setConsultorUpdatingData(internalCode: string,) {
    localStorage.removeItem('consultor');
    localStorage.removeItem('qr');
    localStorage.removeItem('phone');
    localStorage.removeItem('consultorName');
    localStorage.removeItem('user');
    localStorage.removeItem('agency');
    const session = localStorage.getItem('session');
    const deviceInfo = this.getDeviceInfo();

    return this.httpClient.post(`${ environment.serverUrl }/setConsultorUpdatingData`, {consultor:internalCode, session})
    .pipe(
      tap((response:any) => {
        this.localstorageService.set('consultor', internalCode);
        this.localstorageService.set('session', response.token);
        this.localstorageService.set('qr', `${environment.serverUrl}/assets/qr/${ response.qrCode }`);
        this.localstorageService.set('phone', response.phone);
        this.localstorageService.set('consultorName', response.name);
        this.localstorageService.set('user', response.user);
        this.consultor.next({
            phone: response.phone,
            name: response.name,
            user: response.user,
            qrImage:`${environment.serverUrl}/assets/qr/${ response.qrCode }`
        });
      }),
      tap(() => {
        FingerprintJS.load().then(fp => {
            fp.get().then(result => {
              const fingerprint = result.visitorId;
              this.completeDeviceInfo = {
                ...deviceInfo,
                fingerprint,
                web_version: localStorage.getItem('version'),
              };

              this.setDeviceData(this.completeDeviceInfo).subscribe({
                next: (response:any) => {
              },
              error: (error:any) => {
                console.error('Error', error);
              }});
            });
          });
      }),
      catchError((error: any) => {
        if (!isInvalidCredentialsError(error)) {
          toast.error('No fue posible encontrar el asesor que intentas consultar.');
        }
        return throwError(() => error);
      })
    )
  }

  getServices() {
    return this.httpClient.post(`${ environment.serverUrl }/getActiveServices`, {})
    .pipe(
      catchError((error: any) => {
        if(error.status === 0) {
          this.hasInternetSubject.next(false);
        }
        if (error.status === 401 || (error.status === 403)) {
          localStorage.clear();
          this.router.navigate(['/']);
          return this.getNewSession(null);
        }
        return error;
      }),
      map((response: any) => {
        this.hasInternetSubject.next(true);
        return response;
      })
    )
    ;
  }

  //Validation Identification
  checkBlockIdentification(identification: number) {
    return this.httpClient.post(`${ environment.serverUrl }/checkIdentification`, {nIdentificacion: identification});
  }

  setTypedPersonData(identificationType: string | number, identification: string, email: string, phone: string, fullname: string, birthday: string | Date, nationalityId: string | number,) {
    return this.httpClient.post(`${ environment.serverUrl }/setTypedPersonData`,
      {identificationType, identification, email, phone, fullname, birthday, nationalityId}
    );
  }

  setTypedPersonDataUpdating(identificationType: string | number, identification: string, email: string, phone: string, birthday?: string | Date | null) {
    return this.httpClient.post(`${ environment.serverUrl }/setTypedPersonDataUpdating`,
      {identificationType, identification, email, phone, birthday}
    );
  }

  setBirthdate(birthdate: string | Date) {
    return this.httpClient.post(`${ environment.serverUrl }/setBirthdate`, { birthdate });
  }

  checkAddress(address: any) {
    return this.httpClient.post(`${ environment.serverUrl }/checkAddress`, {address});
  }

  confirmAddress(valid: boolean) {
    return this.httpClient.post(`${ environment.serverUrl }/validateAddress`, { valid });
  }

  setAddressData(addressData: any) {
    return this.httpClient.post(`${ environment.serverUrl }/setAddressData`, {addressData});
  }

  getAddressData() {
    return this.httpClient.post(`${ environment.serverUrl }/getAddressData`, {});
  }

  setPapData(papData: any) {
    return this.httpClient.post(`${ environment.serverUrl }/app/pap/addPap`, {papData});
  }

  getPDF() {
    return this.httpClient.post(`${ environment.serverUrl }/getPDF`, {});
  }

  getPDFUpdatingData() {
    return this.httpClient.post(`${ environment.serverUrl }/getPDFUpdatingData`, {});
  }

  getInterfazApp() {
    return this.httpClient.get(`${environment.serverUrl}/getInterfazApp`)
  }

  getQuota() {
    return this.httpClient.get(`${environment.serverUrl}/app/contributions/getQuota`);
  }

  getConsultorPercents(consultorUser: string): Observable<any> {
    return this.httpClient.post(`${environment.serverUrl}/app/listConsultor/getConsultorPercents`, {consultorUser})
  }

  findOnBoardingByIdenfitication(){
    return this.httpClient.get(`${ environment.serverUrl }/findOnBoardingByIdenfitication`);
  }

  getFrontVersion(): Observable<any> {
    return this.httpClient.get(`${environment.serverUrl}/getFrontVersionActu`,)
  }

  getDataLatestOnboarding() {
    return this.httpClient.get(`${ environment.serverUrl }/getLatestOnBoardingByIdentification`);
  }

  checkValidation() {
    return this.httpClient.get(`${ environment.serverUrl }/checkValidation`);
  }
}
